import commonUtil from '../../../utils/commonUtil';

export const USER_LOGIN = 'USER_LOGIN';
export const USER_LOGIN_SUCCESS = 'USER_LOGIN_SUCCESS';
export const USER_LOGIN_FAIL = 'USER_LOGIN_FAIL';
export const USER_REGISTRATION = 'USER_REGISTRATION';
export const USER_REGISTRATION_SUCCESS = 'USER_REGISTRATION_SUCCESS';
export const USER_REGISTRATION_FAIL = 'USER_REGISTRATION_FAIL';
export const USER_LOGOUT = 'USER_LOGOUT';
export const USER_LOGOUT_SUCCESS = 'USER_LOGOUT_SUCCESS';
export const USER_LOGOUT_FAIL = 'USER_LOGOUT_FAIL';

export const USER_ACTIVE_SESSION = 'USER_ACTIVE_SESSION';
export const USER_ACTIVE_SESSION_SUCCESS = 'USER_ACTIVE_SESSION_SUCCESS';
export const USER_ACTIVE_SESSION_FAIL = 'USER_ACTIVE_SESSION_FAIL';

export function _handleUserLogin(userCredential) {
  const userData = userCredential;
  userData.brandName = commonUtil.getBrand().toUpperCase();
  userData.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL],
    promise: client => client.post('/api/currentUser/login', {
      data: (userData),
    }), // params not used, just shown as demonstration
  };
}

export function _handleUserRegistration(userRegistrationForm) {
  const userData = userRegistrationForm;
  userData.brandName = commonUtil.getBrand().toUpperCase();
  userData.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [USER_REGISTRATION, USER_REGISTRATION_SUCCESS, USER_REGISTRATION_FAIL],
    promise: client => client.post('/api/currentUser/create', {
      data: userData,
    }), // params not used, just shown as demonstration
  };
}

export function _isUserinfoLoaded(globalState) {
  return globalState.user && globalState.user.loaded;
}

export function _fetchProfileEventsInfo() {
  const userData = {};
  userData.brandName = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [USER_ACTIVE_SESSION, USER_ACTIVE_SESSION_SUCCESS, USER_ACTIVE_SESSION_FAIL],
    promise: client => client.post('/api/profile/fetchProfileEventsInfo', {
      data: userData,
    }), // params not used, just shown as demonstration
  };
}

export function _isActiveSessionAvailable() {
  const userData = {};
  userData.brandName = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [USER_ACTIVE_SESSION, USER_ACTIVE_SESSION_SUCCESS, USER_ACTIVE_SESSION_FAIL],
    promise: client => client.post('/api/profile/isActiveSessionAvailable', {
      data: userData,
    }), // params not used, just shown as demonstration
  };
}
export function loadUserInfo() {
  return {
    types: [USER_LOGIN, USER_LOGIN_SUCCESS, USER_LOGIN_FAIL],
    promise: client => client.get('/api/profile/load-auth'),
  };
}

export function handleUserLogout(userLogout) {
  const userData = userLogout;
  userData.brand = commonUtil.getBrand();
  userData.channel = commonUtil.getChannel();
  return {
    types: [USER_LOGOUT, USER_LOGOUT_SUCCESS, USER_LOGOUT_FAIL],
    promise: client => client.post('api/profile/logout', {
      data: userData,
    }),
  };
}
